// extracted by mini-css-extract-plugin
export default {"buttonLogo":"ButtonLogo_buttonLogo__iw0v8"};